import { AnalyticIdentifier } from '@common/neo.tax';

import { useAnalyticId } from '@neo.tax/shared/state';

interface UseProductSelectionAnalyticIds {
  productSelectionModalCancelBtnId: string;
  productSelectionModalSelectBtnId: string;
  productSelectionModalProductSelect: string;
}

export const useProductSelectionAnalyticIds = (): UseProductSelectionAnalyticIds => {
  const productSelectionModalCancelBtnId = useAnalyticId(AnalyticIdentifier.PRODUCT_SELECTION_MODAL_CANCEL_BUTTON);
  const productSelectionModalSelectBtnId = useAnalyticId(AnalyticIdentifier.PRODUCT_SELECTION_MODAL_SELECT_BUTTON);
  const productSelectionModalProductSelect = useAnalyticId(AnalyticIdentifier.PRODUCT_SELECTION_MODAL_PRODUCT_SELECT);

  return {
    productSelectionModalCancelBtnId,
    productSelectionModalSelectBtnId,
    productSelectionModalProductSelect,
  };
};
